<template>
  <el-table
    border
    :data="tableOptions.tableData"
    v-bind="$attrs"
    max-height="60vh"
    row-key="id"
    ref="table"
    default-expand-all
  >
    <template v-for="(col, index) in tableOptions.colList" :key="index">
      <!-- 普通 不带插槽 -->
      <el-table-column
        v-if="!col.slot_name"
        :align="col.align || 'center'"
        v-bind="col"
      />

      <!-- 带插槽 -->
      <el-table-column v-else :align="col.align || 'center'" v-bind="col">
        <template #default="{ row, $index }">
          <slot :name="col.slot_name" :row="row" :$index="$index"></slot>
        </template>
      </el-table-column>
    </template>
  </el-table>
</template>

<script setup>
import { ref } from "vue";
const props = defineProps({
  tableOptions: {
    type: Object,
    required: true,
    default: () => ({
      tableData: [],
      colList: [],
    }),
  },
});

const table = ref();
defineExpose({
  table,
});
</script>

<style lang="scss" scoped>
:deep() {
  --el-table-bg-color: #03386a;// 表格背景色
  --el-table-header-bg-color: #124E91 !important;// 表格头部背景色
  --el-table-header-text-color: #6fcaf7 !important;// 表格头部文字颜色
  --el-table-tr-bg-color: #03386a;// 表格行背景色
  --el-table-border-color: #0F59A0;// 表格边框色
  --el-table-text-color: #6fcaf7; // 表格文字颜色
  --el-table-row-hover-bg-color: #104573;// 表格行hover背景色
  // .cell{
  //       display: flex;
  //       align-items: center;
  // }
  // .el-icon{
  //   color: #fff;
  //   font-size: 20px;
  // }
}
</style>
